export enum BrandSelectModalTestIds {
  BRAND_LIST_CONTAINER = 'brand_select_modal_list_container',
  BRAND_LIST_ITEM = 'brand_select_modal_list_item',
  BRAND_SEARCH_BUTTON = 'brand_select_modal_search_button',
}

export enum TeamSelectModalTestIds {
  TEAM_LIST_CONTAINER = 'team_select_modal_list_container',
  TEAM_LIST_ITEM = 'team_select_modal_list_item',
  SEARCH_INPUT = 'team_select_modal_search_input',
}

export enum SelectModalTestIds {
  TITLE = 'select_modal_title',
  HEADER_TEXT = 'select_modal_header_text',
  CLOSE_BUTTON = 'select_modal_close_button',
}

export enum UserSelectModalTestIds {
  SEARCH_INPUT = 'user_select_modal_search_input',
}
